import React, { Component } from "react";
// react component that creates a form divided into multiple steps
import StepZilla from "react-stepzilla";
import { Grid, Row, Col } from "react-bootstrap";

import Card from "../../../components/Card/Card.jsx";
import SelectChange_Step1 from "./SelectChange_Step1";
import Finish_Step2 from "./Finish_Step2.jsx";

import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import * as loginActions from '../../../actions/loginActions';
import * as tenantActions from '../../../actions/tenantActions';
import rest from "../../../API/api";

class ManageSubscriptionWizard extends Component {
    constructor(props) {
        super(props);
        //Lets get current Tenant information loaded in to Redux Store and then place those values into this subscription
        //event local state.  I will pass this state to each step in the wizard since the wizard does not support accessing
        //a redux store directly in each step except the first step
        this._readTenant = this._readTenant.bind(this);
        this.getStore = this.getStore.bind(this);
        this.updateStore = this.updateStore.bind(this);
        this.state = {};
        this.subscriptionEvent = {
            //These are the fields that I need to store for the consent submission not the consent form settings
            RequestingTenantId: "",
            EventType: "",
            Fname: "",
            Lname: "",
            Address: "",
            City: "",
            State: "",
            Country: "",
            Postal: "",
            Phone: "",
            Company: "",
            Email: "",
            SubscriptionType: "",
            SubscriptionMultiShopCount: 0,
            SubscriptionDate: "",
            SubscriptionPrice: 0,
            Userid: "",
            Hash: "",
            Salt: "",
            CCNumber: "",
            CCName: "",
            CCExpiry: "",
            CCCvc: "",
            CCIssuer: "",
            CCZip: "",
            focused: "",
            formData: null,
            sentEmail: false,
            Notes: "",
            //Used in step one to get event type and Change text
            SubscriptionChange: "",
        };
        this._readTenant(this.props.userLoggedIn[0],this.props.id);
    }

    _readTenant(tenant,id){
        let tempURL = rest.tenants + '/' + id;
        fetch(tempURL, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': tenant.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {
                var subscriptionEventUpdate = {
                    //These are the fields that I need to store for the consent submission not the consent form settings
                    RequestingTenantId: data._id,
                    Fname: data.Fname,
                    Lname: data.Lname,
                    Address: data.Address,
                    City: data.City,
                    State: data.State,
                    Country: data.Country,
                    Postal: data.Postal,
                    Company: data.Company,
                    Email: data.Email,
                    Phone: data.Phone,
                    SubscriptionType: data.SubscriptionType,
                    SubscriptionMultiShopCount: data.SubscriptionMultiShopCount,
                    SubscriptionDate: data.SubscriptionDate,
                    SubscriptionPrice: data.SubscriptionPrice,
                    Userid:data.Userid,
                    Hash: data.Hash,
                    Salt:data.Salt,
                    CCNumber: "",
                    CCName: "",
                    CCExpiry: "",
                    CCCvc: "",
                    CCIssuer: "",
                    CCZip: "",
                    focused: "",
                    formData: null,
                    sentEmail: false,
                    Notes: "",
                    //Used in step one to get event type and Change text
                    SubscriptionChange: "",
                };
                this.updateStore(subscriptionEventUpdate);
                return (data);
            })
            .catch(error => console.error(error));

    }

    static get contextTypes() {
        return {
            router: PropTypes.object
        };
    }

    componentDidMount() {}

    componentWillUnmount() {}

    //Will use local store to keep items entered on this submission
    getStore() {
        return this.subscriptionEvent;
    }

    updateStore(update) {
        this.subscriptionEvent = {
            ...this.subscriptionEvent,
            ...update,
        }
    }

    render() {
        if ((this.props.userLoggedIn[0].status)) {
            const steps = [
                {
                    name: "What do you want to change?",
                    component: <SelectChange_Step1 getStore={() => (this.getStore())} updateStore={(u) => {
                        this.updateStore(u)
                    }} subscriptionEvent={this.subscriptionEvent}
                                                   userId={this.props.userLoggedIn[0]._id}
                                                   tenant={this.props.userLoggedIn[0]}/>
                },
                /*
                {
                    name: "Your changes",
                    component: <Step2 getStore={() => (this.getStore)} updateStore={(u) => {
                        this.updateStore(u)
                    }} subscriptionEvent={this.subscriptionEvent}
                      userId={this.props.userLoggedIn[0]._id}
                      tenant={this.props.userLoggedIn[0]}/>
                },*/
                {
                    name: "Finishing Up", component: <Finish_Step2
                        getStore={() => (this.getStore())}
                        updateStore={(u) => {
                            this.updateStore(u)
                        }}
                        clearStore={() => {
                            this.clearStore()
                        }}
                        subscriptionEvent={this.subscriptionEvent}
                        userRole={this.props.userLoggedIn[0].role}
                        userId={this.props.userLoggedIn[0]._id}
                        tenant={this.props.userLoggedIn[0]}

                    />
                },
            ];
            return (
                <div className="main-content"
                     style={{backgroundImage: "url(" + require("../../../assets/img/matrix.jpg") + ")"}}>
                    <Grid fluid>
                        <Row>
                            <Col md={10} mdOffset={1}>
                                <Card
                                    wizard
                                    id="wizardCard"
                                    textCenter
                                    title="Manage My Subscription"
                                    category="Make changes to your existing TRO Subscription"
                                    content={
                                        <StepZilla
                                            steps={steps}
                                            stepsNavigation={false}
                                            nextButtonCls="btn btn-prev btn-info btn-fill pull-right btn-wd"
                                            backButtonCls="btn btn-next btn-default btn-fill pull-left btn-wd"
                                        />
                                    }
                                />
                            </Col>
                        </Row>
                    </Grid>
                </div>
            );
        } else {
            alert("You must be logged in to access this page!");
            this.context.router.history.push("/pages/login-page");
            return (null);
        }

    }
}

ManageSubscriptionWizard.propTypes = {
    loginActions: PropTypes.object.isRequired,
    userLoggedIn: PropTypes.array.isRequired,
    tenant: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        userLoggedIn: state.userLoggedIn,
        tenant: state.tenant,
        id: state.userLoggedIn[0]._id
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loginActions: bindActionCreators(loginActions, dispatch),
        tenantActions: bindActionCreators(tenantActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageSubscriptionWizard);




// WEBPACK FOOTER //
// ./src/views/Forms/ManageSubscriptionWizard/ManageSubscriptionWizard.jsx